import {GetObjectCommand, HeadObjectCommand, ListObjectsV2Command, PutObjectCommand} from "@aws-sdk/client-s3";
import global from "../global"
import {dataURLToFile} from "../../@excalidraw/packages/excalidraw/data/blob";
import {
    blobToBase64,
    blobToFile,
    convertImageToWebp,
    getFileNameExt,
    imgToBase64SVG,
    streamBufsToBase64
} from "../utils";
import {getClient} from "./Aws";
import {arrayBufferToString} from "nx/src/adapter/ngcli-adapter";

const AWS_S3_PRE_DATA_URL = "https://noteey-web-app.s3.amazonaws.com/";

function getRootDir(){
    return 'web-app-test/'+global.g_userInfo?.id;
}
function getThumbDir(){
    return getRootDir() + '/thumbs/';
}
function getFileDir(){
    return getRootDir() + '/files/'
}
function getImageDir(){
    return getRootDir() + '/images/';
}

/**
 * 计算大小
 */
export function staticS3Size(){
    let listObjects = new ListObjectsV2Command({
        Bucket:'noteey-web-app',
        Prefix: getRootDir(),
        MaxKeys: 1000
    })
    return new Promise((resolve, reject) => {
        getClient().send(listObjects).then(data=>{
            console.log(data);
            let nSize:any = 0;
            if (data.Contents){
                 data.Contents.forEach(p=>{
                     nSize += p.Size;
                 })
            }

            resolve(Math.round(nSize/1024/1024)+'Mb');
        })
    })

}

/**
 * 上传首页base64 缩略图
 * @param szId
 * @param szBase64
 */
export async function uploadS3ImageThumb(szId:string,szBase64:string){
    if (!szBase64)return '';
    let body = dataURLToFile(szBase64,szId+'.png');
    const blob = await convertImageToWebp(szBase64);
    body = blobToFile(blob);

    const szKey = getThumbDir()+szId+'.webp'
    const command = new PutObjectCommand({
        Bucket:'noteey-web-app',
        Key:szKey,
        Body:body
    })
    getClient().send(command);
    return AWS_S3_PRE_DATA_URL+szKey;
}

/**
 * 上传内部的图片
 * @param szId
 * @param szBase64
 */
export async function uploadS3Base64Image(szId:string,szBase64:string){
    if (!szBase64)return '';
    let body = dataURLToFile(szBase64,szId+'.jpg');

    const szKey = getImageDir()+szId+'.jpg'
    const command = new PutObjectCommand({
        Bucket:'noteey-web-app',
        Key:szKey,
        Body:body
    })
    getClient().send(command);
    return AWS_S3_PRE_DATA_URL+szKey;
}

/**
 * 上传内部的图片
 * @param szId
 * @param szBase64
 */
export async function uploadS3File(szElementId:string,file:any,type:'image'|'file'){
    let szDir = getImageDir();
    if (type == "file"){
        szDir = getFileDir();
    }
    const szKey = szDir+szElementId+"."+getFileNameExt(file.name);
    const command = new PutObjectCommand({
        Bucket:'noteey-web-app',
        Key:szKey,
        Body:file
    })
    return new Promise(async (resolve, reject) => {
        await getClient().send(command);
        resolve(AWS_S3_PRE_DATA_URL+szKey);
    })
}

/**
 * 下载s3的图片....
 * @param arrayElements
 */
export async function downloadS3ImageToBase64(arrayElements:any){
    var arrayFiles:any = {};
    var arrayGetCommands:any = [];
    for (let i=0;i<arrayElements.length;i++){
        const element = arrayElements[i];
        if (element.type == 'image' && element.data && element.data.length > 0){
            const cmd = new GetObjectCommand({
                Bucket:'noteey-web-app',
                Key:element.data[0].replace(AWS_S3_PRE_DATA_URL,'')
            })
            // arrayGetCommands.push(cmd);
            const {Body} = await getClient().send(cmd);
            const bufs  = await Body.transformToByteArray();
            const szBase64 = streamBufsToBase64(bufs);
            const szImageBase64 = 'data:image/'+'png'+';base64,'+szBase64;
            var item = {
                mimeType: 'image/png',
                id: element.fileId,
                dataURL: szImageBase64,
                created: Date.now(),
                lastRetrieved: Date.now()
            }
            arrayFiles[item.id] = item;
        }
    }
    return arrayFiles;

    // const res:any = await Promise.all(arrayGetCommands.map(p=>getClient().send(p).catch(err=>{
    //     return null;
    // })))
    // for (let i=0;i<res.length;i++){
    //     if (res[i] == null)continue;
    //     const bufs  = await res[i].Body.transformToByteArray();
    //     const szBase64 = streamBufsToBase64(bufs);
    //     const szImageBase64 = 'data:image/'+'png'+';base64,'+szBase64;
    //     var item = {
    //         mimeType: c.mimeType,
    //         id: c.id,
    //         dataURL: szImageBase64,
    //         created: Date.now(),
    //         lastRetrieved: Date.now()
    //     }
    //     arrayFuckEx.push(item);
    // }
}





























